<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="natural-questions">
        <div class="natural-questions-form">
          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              一、您是否满足下列条件？ <br/>
              1）金融资产不低于500万元人民币，或者最近3年个人年均收入不低于50万元人民币;
                <br/>
              2）具有2年以上证券、基金、期货、黄金、外汇等投资经历，
                或者具有2年以上金融产品设计、投资、风险管理及相关工作经历的自然人投资者，
                或者属于《证券期货投资者适当性管理办法》第八条第（一）款所规定的专业投资者的高级管理人员、
                获得职业资格认证的从事金融相关业务的注册会计师和律师。
            </div>
            <div class="natural-questions-form-item-content">
              <cube-validator
                ref="userInvestmentExperience"
                v-model="result[0]"
                :model="Model.userInvestmentExperienceChecked"
                :rules="Rules.userInvestmentExperienceChecked"
                :messages="Messages.userInvestmentExperienceChecked">
                <cube-radio-group
                  v-model="Model.userInvestmentExperienceChecked"
                  :options="[
                    {label: '是', value: '是', disabled: $_isDisable()},
                    {label: '否', value: '否', disabled: $_isDisable()}
                  ]"
                  :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>
          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              二、私募基金或者资产管理计划投资者，
              最近20个交易日金融资产均不得低于人民币300万元，
              或者最近3年个人年均收入不低于人民币50万元
            </div>
            <div class="natural-questions-form-item-content">
              <cube-validator
                ref="userAssetsScale"
                v-model="result[1]"
                :model="Model.userAssetsScaleChecked"
                :rules="Rules.userAssetsScaleChecked"
                :messages="Messages.userAssetsScaleChecked">
                <cube-radio-group
                  v-model="Model.userAssetsScaleChecked"
                  :options="['是', '否']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>

          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              三、是否存在实际控制关系？
            </div>
            <div class="natural-questions-form-item-content">
              <cube-validator
                ref="isControllingShareholder"
                v-model="result[2]"
                :model="Model.isControllingShareholderChecked"
                :rules="Rules.isControllingShareholderChecked"
                :messages="Messages.isControllingShareholderChecked">
                <cube-radio-group
                  v-model="Model.isControllingShareholderChecked"
                  :options="['是', '否']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
              <cube-validator
                v-if="Model.isControllingShareholderChecked === '是'"
                ref="isControllingShareholderDesc"
                v-model="result[3]"
                :model="Model.isControllingShareholderDescription"
                :rules="Rules.isControllingShareholderDescription"
                :messages="Messages.isControllingShareholderDescription">
                <cube-textarea
                  v-model="Model.isControllingShareholderDescription"
                  :indicator="false"
                  placeholder="请说明"
                  style="font-size:12px;">
                </cube-textarea>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>
          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              四、交易的实际受益人？
            </div>
            <div class="natural-questions-form-item-content">
              <cube-validator
                ref="transactionActualBeneficiary"
                v-model="result[4]"
                :model="Model.transactionActualBeneficiaryChecked"
                :rules="Rules.transactionActualBeneficiaryChecked"
                :messages="Messages.transactionActualBeneficiaryChecked">
                <cube-radio-group
                  v-model="Model.transactionActualBeneficiaryChecked"
                  :options="['本人', '他人']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
              <cube-validator
                v-if="Model.transactionActualBeneficiaryChecked === '他人'"
                ref="transactionActualBeneficiaryDesc"
                v-model="result[5]"
                :model="Model.transactionActualBeneficiaryDescription"
                :rules="Rules.transactionActualBeneficiaryDescription"
                :messages="Messages.transactionActualBeneficiaryDescription">
                <cube-textarea
                  v-model="Model.transactionActualBeneficiaryDescription"
                  :indicator="false"
                  placeholder="请说明"
                  style="font-size:12px;">
                </cube-textarea>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>

          </div>

          <div class="natural-questions-form-item">
            <div class="natural-questions-form-item-title">
              五、是否有不良诚信记录？
            </div>
            <div class="natural-questions-form-item-content">
              <cube-validator
                ref="isBadFaith"
                v-model="result[6]"
                :model="Model.isBadFaithChecked"
                :rules="Rules.isBadFaithChecked"
                :messages="Messages.isBadFaithChecked">
                <cube-radio-group
                  v-model="Model.isBadFaithChecked"
                  :options="['是', '否']" :horizontal="true">
                </cube-radio-group>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
              <cube-validator
                v-if="Model.isBadFaithChecked === '是'"
                ref="isBadFaithDesc"
                v-model="result[7]"
                :model="Model.isBadFaithDescription"
                :rules="Rules.isBadFaithDescription"
                :messages="Messages.isBadFaithDescription">
                <cube-textarea
                  v-model="Model.isBadFaithDescription"
                  :indicator="false"
                  placeholder="请说明"
                  style="font-size:12px;">
                </cube-textarea>
                <div slot="message" slot-scope="props" class="cube-validator-msg-custom">
                  <span v-if="(props.dirty || props.validated) && !props.validating" class="">
                    {{ props.message }}
                  </span>
                </div>
              </cube-validator>
            </div>

          </div>
        </div>

        <div class="foot-btn">
          <cube-button @click="$_handleValidate">确认</cube-button>
        </div>

      </div>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getInvestorInfoDraftSave } from '@/api/investor';
import cmixin from '../../commonConfig';

export default {
  data() {
    return {
      result: [undefined, undefined, undefined, undefined, undefined, undefined],
      Model: {
        userInvestmentExperienceChecked: null,
        userAssetsScaleChecked: null,
        isControllingShareholderChecked: null,
        isControllingShareholderDescription: '',
        transactionActualBeneficiaryChecked: null,
        transactionActualBeneficiaryDescription: '',
        isBadFaithChecked: null,
        isBadFaithDescription: '',
      },
      Rules: {
        userInvestmentExperienceChecked: {
          required: true,
        },
        userAssetsScaleChecked: {
          required: true,
        },
        isControllingShareholderChecked: {
          required: true,
        },
        isControllingShareholderDescription: {
          required: true,
        },
        transactionActualBeneficiaryChecked: {
          required: true,
        },
        transactionActualBeneficiaryDescription: {
          required: true,
        },
        isBadFaithChecked: {
          required: true,
        },
        isBadFaithDescription: {
          required: true,
        },
      },
      Messages: {
        userInvestmentExperienceChecked: {
          required: '请选择',
        },
        userAssetsScaleChecked: {
          required: '请选择',
        },
        isControllingShareholderChecked: {
          required: '请选择',
        },
        isControllingShareholderDescription: {
          required: '请说明',
        },
        transactionActualBeneficiaryChecked: {
          required: '请选择',
        },
        transactionActualBeneficiaryDescription: {
          required: '请说明',
        },
        isBadFaithChecked: {
          required: '请选择',
        },
        isBadFaithDescription: {
          required: '请说明',
        },
      },
    };
  },
  mixins: [cmixin],
  computed: {
    ...mapGetters(['managerInfo', 'au']),
  },
  watch: {
    'Model.userAssetsScaleChecked': {
      handler(val) {
        this.$_handleChedckedToast(val);
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者问卷信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('草稿', obj);
        this.$_handlerInit(obj.baseInfo);
      });
    }, 300);
  },
  methods: {
    /**
     * 初始数据
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      if (data && this.isUndifined(obj)) {
        this.Model.userInvestmentExperienceChecked = JSON.parse(obj.userInvestmentExperience).checked;
        this.Model.userAssetsScaleChecked = JSON.parse(obj.userAssetsScale).checked;
        this.Model.isControllingShareholderChecked = JSON.parse(obj.isControllingShareholder).checked;
        this.Model.isControllingShareholderDescription = JSON.parse(obj.isControllingShareholder).description;
        this.Model.transactionActualBeneficiaryChecked = JSON.parse(obj.transactionActualBeneficiary).checked;
        this.Model.transactionActualBeneficiaryDescription = JSON.parse(obj.transactionActualBeneficiary).description;
        this.Model.isBadFaithChecked = JSON.parse(obj.isBadFaith).checked;
        this.Model.isBadFaithDescription = JSON.parse(obj.isBadFaith).description;
      } else {
        if (this.managerInfo.invenstemType === 'SPECIFIC_PERSONAL_ORDINARY') {
          this.Model.userInvestmentExperienceChecked = '否';
        }
        if (this.managerInfo.invenstemType === 'SPECIFIC_PERSONAL_PROFESSION') {
          this.Model.userInvestmentExperienceChecked = '是';
        }
      }
    },
    isUndifined(obj) {
      return obj.userInvestmentExperience || obj.userAssetsScale
      || obj.isControllingShareholder || obj.transactionActualBeneficiary || obj.isBadFaith;
    },
    /**
     * 表单校验
     * @return {[type]} [description]
     */
    $_handleValidate() {
      this.$nextTick(() => {
        let Refs = [];
        Refs = Object.keys(this.$refs).filter(item => this.$refs[item] !== undefined);
        Promise.all(Refs.map(key => this.$refs[key].validate())).then((valid) => {
          this.result = valid;
          if (valid.every(item => item)) {
            this.$_handleSaveDraft();
          }
        });
      });
    },
    $_handlerFormatData() {
      const selectModel = {
        userInvestmentExperience: {
          checked: this.Model.userInvestmentExperienceChecked,
        },
        userAssetsScale: {
          checked: this.Model.userAssetsScaleChecked,
        },
        isControllingShareholder: {
          checked: this.Model.isControllingShareholderChecked,
          description: this.Model.isControllingShareholderDescription,
        },
        transactionActualBeneficiary: {
          checked: this.Model.transactionActualBeneficiaryChecked,
          description: this.Model.transactionActualBeneficiaryDescription,
        },
        isBadFaith: {
          checked: this.Model.isBadFaithChecked,
          description: this.Model.isBadFaithDescription,
        },
      };
      return selectModel;
    },
    /**
     * 保存草稿箱
     * @return {[type]} [description]
     */
    $_handleSaveDraft() {
      const selectModel = this.$_handlerFormatData();
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      getInvestorInfoDraftSave({
        draftsNo: this.$route.query.draftsNo,
        financialUserId: this.managerInfo.userId,
        specificCode: this.managerInfo.invenstemType,
        investorInfoQuestion: JSON.stringify(selectModel),
      }, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          this.$bridge.callHandler('getResult', { msg: '投资者问卷草稿箱', json: JSON.stringify(selectModel) }, () => {
          });
        } else {
          this.$createToast({
            type: 'txt',
            txt: res.msg,
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
    /**
     * 第一题是否可选择性
     * @return {Boolean} [description]
     */
    $_isDisable() {
      if (this.managerInfo.invenstemType === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
        return false;
      }
      return true;
    },
    /**
     * 第二题选项提示
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    $_handleChedckedToast(val) {
      // 普通投资者、专业投资者可以选择"是"，选择“否”提示用户流程不在继续
      if (this.managerInfo.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS') {
        if (val === '否') {
          const str = `根据《证券期货投资者适当性管理办法》第十四条“一定时期”的规定，
          私募基金合格投资者必须满足该条件，若您确认选否，该投资者则不符合私募基金购买条件，
          我们将终止本投资者信息表的填写。`;
          this.$createDialog({
            type: 'alert',
            title: '提示',
            content: str,
            onConfirm: () => {
              this.$set(this.Model, 'userAssetsScaleChecked', '是');
            },
          }).show();
        }
      }
      // 员工跟股可以选择“是”也可选择“否”，选择“否”提示用户无需签署合格投
      if (this.managerInfo.invenstemType === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
        if (val === '否') {
          const str = `根据《私募投资基金募集行为管理办法》第32条规定，该项选“否”，
          我们将标记该投资者为“投资于所管理私募基金的私募基金管理人的员工跟投”，
          确认其为当然合格投资者，后续无需签署合格投资者承诺函，是否确认选“否”？`;
          this.$createDialog({
            type: 'alert',
            title: '提示',
            content: str,
          }).show();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.natural-questions {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .natural-questions-form {
    .natural-questions-form-item {
      padding: 16px;
      background: #fff;
      margin-bottom: 10px;
      .natural-questions-form-item-title {
        font-size: 12px;
        margin-bottom: 8px;
        color: #666;
        line-height: 18px;
      }
      .natural-questions-form-item-content {
        .cube-validator-msg-custom {
          font-size: 12px;
          color: red;
          margin-top: 5px;
        }
      }

    }
  }
}
</style>
